import { useTranslation } from "react-i18next";

import scherma from "../../assets/foto/about-scherma.jpg";
import ricostruzione from "../../assets/foto/about-ricostruzione.jpg";

function About() {
  const { t } = useTranslation();

  return (
    <section id="chi-siamo" className="base-section">
      <div className="base-text-container order-1 md:order-2">
        <h2 className="base-title">{t("about.title")}</h2>
        <p className="base-paragraph">{t("about.text1")}</p>
        <p className="base-paragraph">{t("about.text2")}</p>
      </div>
      <div className="grid grid-cols-2 gap-4 mt-8 order-2 md:order-1">
        <img className="base-image" src={scherma} alt="foto-scherma" />
        <img
          className="base-image"
          src={ricostruzione}
          alt="foto-ricostruzione"
        />
      </div>
    </section>
  );
}

export default About;
